
"use strict";
import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { DIALOG_AUX_FUNCTIONS } from "../util/classes";
import { Whisper } from "../util/classes";
import { UTL } from "../util/classes";
import { VECTOR, VECTOR_Task, VECTOR_Capsule, VECTOR_Info } from "../util/classes";

//ADD_KABIN
// working on it

/**
 * DIALOG500 Static Class
 * we chose the number 500 becuse in HTTP 500 means “Internal Server Error”
 */
export class DIALOG500 {
    // --- Static Elements (Variables) ---
    public static popup_exist: boolean = false; // בהמשך אולי נשנה את השם הזה

    public static overlay_element: HTMLElement = null;
    public static popup_element: HTMLElement = null;
    public static caption_element: HTMLElement = null;
    public static case_element: HTMLElement = null;
    public static close_button_element: HTMLSpanElement = null;
    public static defo_button_element: HTMLSpanElement = null; // defo = DEbug FOcu
    public static panel_element: HTMLElement = null;
    public static ok_button_element: HTMLElement = null;
    public static cancel_button_element: HTMLElement = null;

    // --- Static State Variables ---
    public static MD_FLAG = false;
    public static defo_button_is_clicked = false;
    public static Vamod_MouseX = 0;
    public static Vamod_MouseY = 0;
    public static Vamod_ModalWindowLeftX = 0;
    public static Vamod_ModalWindowTopY = 0;
    public static par_text_content = "";

    public static readonly BID = {
        UNDEFINED: 0,
        OK: 1,
        CANCEL: 2,
    }; // note that we need this ';' because this block is a command 

    public static var_current_pseudo_focused_btn = 1; // BID.OK

    // --- Methods ---

    public static refresh_pseudo_focus_for_all_buttons() {
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG500.ok_button_element, DIALOG500.var_current_pseudo_focused_btn == DIALOG500.BID.OK);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG500.cancel_button_element, DIALOG500.var_current_pseudo_focused_btn == DIALOG500.BID.CANCEL);
    }

    public static respond_tab() {
        DIALOG500.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Forward(DIALOG500.var_current_pseudo_focused_btn, DIALOG500.BID.OK, DIALOG500.BID.CANCEL);
        DIALOG500.refresh_pseudo_focus_for_all_buttons();
    }

    public static respond_shift_tab() {
        DIALOG500.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Backward(DIALOG500.var_current_pseudo_focused_btn, DIALOG500.BID.OK, DIALOG500.BID.CANCEL);
        DIALOG500.refresh_pseudo_focus_for_all_buttons();
    }

    public static create_overlay_element() {
        const overlay_element = document.createElement("div");
        overlay_element.style.position = "fixed";
        overlay_element.style.top = "0";
        overlay_element.style.left = "0";
        overlay_element.style.width = "100%";
        overlay_element.style.height = "100%";
        overlay_element.style.backgroundColor = "rgba(0, 0, 0, 0.5)"; // Semi-transparent black
        overlay_element.style.zIndex = "1000"; // Ensure overlay is on top
        return overlay_element;
    }

    public static create_popup_element() {
        const popup_element = document.createElement("div");
        popup_element.id = "id-DIALOG500-popup";
        popup_element.style.position = "absolute";
        popup_element.style.backgroundColor = "#fff";
        popup_element.style.padding = "0px";
        popup_element.style.borderRadius = "8px";
        popup_element.style.width = "800px";
        //popup_element.style.height = "600px";
        popup_element.style.textAlign = "center";

        //position: fixed;
        return popup_element;
    }

    public static create_caption_element() {
        const caption = document.createElement("div");
        caption.textContent = "DIALOG500 (error in VECTOR)";
        caption.style.fontSize = "24px";
        caption.style.fontWeight = "bold";
        caption.style.margin = "0px";
        caption.style.padding = "0px";
        caption.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_caption_backgroundColor();
        caption.style.color = DIALOG_AUX_FUNCTIONS.get_caption_forgroundColor();
        caption.style.borderTopLeftRadius = "5px";
        caption.style.borderTopRightRadius = "5px";
        caption.style.userSelect = "none";
        return caption;
    }

    public static create_close_button(): HTMLSpanElement {
        const element = DIALOG_AUX_FUNCTIONS.create_close_button_element();
        return element;
    }

    public static create_defo_button(): HTMLSpanElement {
        const element = DIALOG_AUX_FUNCTIONS.create_defo_button_element();
        return element;
    }

    public static create_case_element() {
        const element = document.createElement("div");
        element.id = "id-DIALOG500-case"; // the id is for debug of focus
        element.style.backgroundColor = "red";
        UTL.remove_outline_for_focusable_element(element);
        element.style.fontSize = "16px";
        //element.style.width = "100%"; // ערך זה נקבע בניסוי וטעיה
        element.style.padding = "22px";
        element.style.margin = "auto";
        element.style.fontWeight = "700";
        element.style.direction = "ltr";
        /*element.style.height = "700px";*/
        //element.textContent = DIALOG500.par_text_content;
        element.innerHTML = DIALOG500.par_text_content;
        return element;
    }

    public static create_panel_element() {
        const buttonsContainer = document.createElement("div");
        buttonsContainer.style.marginTop = "6px";
        buttonsContainer.style.display = "flex";
        buttonsContainer.style.justifyContent = "space-around";
        buttonsContainer.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_panel_backgroundColor();
        buttonsContainer.style.marginBottom = "6px";
        return buttonsContainer;
    }

    public static create_ok_button_element() {
        const element = DIALOG_AUX_FUNCTIONS.create_ok_button_element();
        UTL.MakeElementUnFocusable(element);
        return element;
    }

    public static create_cancel_button_element() {
        const element = DIALOG_AUX_FUNCTIONS.create_cancel_button_element();
        UTL.MakeElementUnFocusable(element);
        return element;
    }

    public static overlay_mousedown(event: MouseEvent) {
        const target_element = event.target;
        if (target_element == DIALOG500.caption_element) {
            // caption אנחנו רוצים שניתן יהיה לגרור רק דרך ה
            // caption אנחנו רוצים שניתן יהיה לגרור רק דרך ה
            const popup_element_bounding_rect = DIALOG500.popup_element.getBoundingClientRect();
            DIALOG500.MD_FLAG = true;
            DIALOG500.Vamod_MouseX = event.clientX;
            DIALOG500.Vamod_MouseY = event.clientY;
            DIALOG500.Vamod_ModalWindowLeftX = popup_element_bounding_rect.left; // here was parseFloat
            DIALOG500.Vamod_ModalWindowTopY = popup_element_bounding_rect.top; // here was parseFloat
        }
        if (target_element == DIALOG500.defo_button_element) {
            DIALOG500.defo_button_is_clicked = true;
        }
    }

    public static overlay_mousemove(event: MouseEvent) {
        if (DIALOG500.MD_FLAG == true) {
            //alert("mouse move");
            const delta_x = event.clientX - DIALOG500.Vamod_MouseX;
            const delta_y = event.clientY - DIALOG500.Vamod_MouseY;
            DIALOG500.popup_element.style.left = (DIALOG500.Vamod_ModalWindowLeftX + delta_x) + "px";
            DIALOG500.popup_element.style.top = (DIALOG500.Vamod_ModalWindowTopY + delta_y) + "px";
            //alert(`mousemove22: delta_x=${delta_x} delta_y=${delta_y}`);
        }
    }

    public static overlay_mouseup(event: MouseEvent) {
        const freezed_defo_button_is_clicked = DIALOG500.defo_button_is_clicked;
        DIALOG500.MD_FLAG = false;
        DIALOG500.defo_button_is_clicked = false;
        if (freezed_defo_button_is_clicked == false) {
            // כי זה יקלקל את הבדיקה case_element אנחנו לא רוצים לבצע פוקוס ל defo_button במקרה שבו לחצנו על ה
            // כי זה יקלקל את הבדיקה case_element אנחנו לא רוצים לבצע פוקוס ל defo_button במקרה שבו לחצנו על ה
            // כי זה יקלקל את הבדיקה case_element אנחנו לא רוצים לבצע פוקוס ל defo_button במקרה שבו לחצנו על ה
            DIALOG500.case_element.focus(); // body בורח ל focus כיוון שה focus יש לבצע כאן
        }
    }

    public static perform_pseudo_focused_button() {
        if (DIALOG500.var_current_pseudo_focused_btn == DIALOG500.BID.OK) {
            DIALOG500.perform_ok();
        }
        if (DIALOG500.var_current_pseudo_focused_btn == DIALOG500.BID.CANCEL) {
            DIALOG500.perform_cancel();
        }
    }

    public static overlay_keydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            //perform_ok();
            DIALOG500.perform_pseudo_focused_button();
        }
        if (event.key === 'Escape') {
            DIALOG500.perform_cancel();
        }
        if (event.key === 'ArrowLeft') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'ArrowRight') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'ArrowDown') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'Delete') {
        }
        if (event.key === 'Backspace') {
        }
        if (event.key === 'Tab') {
            event.preventDefault(); // <-- this disables the default behavior
            if (event.shiftKey == false) DIALOG500.respond_tab();
            if (event.shiftKey == true) DIALOG500.respond_shift_tab();
        }

        if (event.key === 'F7') {
            event.preventDefault(); // <-- this disables the default behavior
            //UTL.show_which_element_has_focus();
        }

        if (event.key === ' ') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (UTL.string_contains_digit(event.key) == true) {
            event.preventDefault(); // <-- this disables the default behavior
        }
    }

    public static create_new_br_element() {
        // אחד חשוב ליצור כל אחד בנפרד כאן <br> במידה ורוצים להוסיף יותר מאשר אלמנט
        const new_br_element = document.createElement('br');
        return new_br_element;
    }

    public static paint_colors_in_select_elements(element: HTMLElement, bval: boolean) {
        if (bval == false) {
            element.style.backgroundColor = "white";
            element.style.color = "black";
        }
        if (bval == true) {
            element.style.backgroundColor = "blue";
            element.style.color = "white";
        }
    }


    public static perform_defo() {
        // defo = DEbug FOcul
        // defo = DEbug FOcul
        // defo = DEbug FOcul
        UTL.show_which_element_has_focus();
    }

    public static create_dialog(p_text_content: string) {
        // כי הוא אמור להקרא במקרה שיש תקלה במסך  DIALOG500 בשם dialog אנחנו מחליטים לקרוא ל
        // כי הוא אמור להקרא במקרה שיש תקלה במסך  DIALOG500 בשם dialog אנחנו מחליטים לקרוא ל
        // כי הוא אמור להקרא במקרה שיש תקלה במסך  DIALOG500 בשם dialog אנחנו מחליטים לקרוא ל
        // כי הוא אמור להקרא במקרה שיש תקלה במסך  DIALOG500 בשם dialog אנחנו מחליטים לקרוא ל

        // we chose the number 500 becuse in HTTP 500 means “Internal Server Error”
        // we chose the number 500 becuse in HTTP 500 means “Internal Server Error”
        // we chose the number 500 becuse in HTTP 500 means “Internal Server Error”
        // we chose the number 500 becuse in HTTP 500 means “Internal Server Error”
        // we chose the number 500 becuse in HTTP 500 means “Internal Server Error”
        // we chose the number 500 becuse in HTTP 500 means “Internal Server Error”

        DIALOG500.popup_exist = true;

        DIALOG500.par_text_content = p_text_content;

        DIALOG500.overlay_element = DIALOG500.create_overlay_element();
        DIALOG500.popup_element = DIALOG500.create_popup_element();
        DIALOG500.caption_element = DIALOG500.create_caption_element();
        DIALOG500.close_button_element = DIALOG500.create_close_button();
        DIALOG500.defo_button_element = DIALOG500.create_defo_button(); // defo = DEbug FOcul

        DIALOG500.case_element = DIALOG500.create_case_element();

        DIALOG500.panel_element = DIALOG500.create_panel_element();
        DIALOG500.ok_button_element = DIALOG500.create_ok_button_element();
        DIALOG500.cancel_button_element = DIALOG500.create_cancel_button_element();

        DIALOG500.overlay_element.appendChild(DIALOG500.popup_element);
        DIALOG500.caption_element.appendChild(DIALOG500.close_button_element);
        DIALOG500.caption_element.appendChild(DIALOG500.defo_button_element);
        DIALOG500.popup_element.appendChild(DIALOG500.caption_element);
        //popup_element.appendChild(create_new_br_element());

        DIALOG500.popup_element.appendChild(DIALOG500.case_element);

        DIALOG500.popup_element.appendChild(DIALOG500.panel_element);
        DIALOG500.panel_element.appendChild(DIALOG500.ok_button_element);
        if (false) {
            // retray כרגע אין לנו לוגיקת retray בעתיד אולי נוסיף גם כפתור ok בשלב זה אנחנו יש לנו רק כפתור אחד
            // retray כרגע אין לנו לוגיקת retray בעתיד אולי נוסיף גם כפתור ok בשלב זה אנחנו יש לנו רק כפתור אחד
            // retray כרגע אין לנו לוגיקת retray בעתיד אולי נוסיף גם כפתור ok בשלב זה אנחנו יש לנו רק כפתור אחד
            // retray כרגע אין לנו לוגיקת retray בעתיד אולי נוסיף גם כפתור ok בשלב זה אנחנו יש לנו רק כפתור אחד
            DIALOG500.panel_element.appendChild(DIALOG500.cancel_button_element);
        }
        DIALOG500.overlay_element.addEventListener("mousedown", DIALOG500.overlay_mousedown);
        DIALOG500.overlay_element.addEventListener("mousemove", DIALOG500.overlay_mousemove);

        DIALOG500.overlay_element.addEventListener("mouseup", DIALOG500.overlay_mouseup);
        DIALOG500.overlay_element.addEventListener("keydown", DIALOG500.overlay_keydown);
        DIALOG500.defo_button_element.addEventListener("click", DIALOG500.perform_defo);
        DIALOG500.ok_button_element.addEventListener("click", DIALOG500.perform_ok);
        DIALOG500.cancel_button_element.addEventListener("click", DIALOG500.perform_cancel);
        DIALOG500.close_button_element.addEventListener("click", DIALOG500.perform_cancel);
        document.body.appendChild(DIALOG500.overlay_element);
        UTL.center_popup_element_inside_overlay_element(DIALOG500.popup_element, DIALOG500.overlay_element);
        DIALOG500.var_current_pseudo_focused_btn = DIALOG500.BID.OK;
        DIALOG500.refresh_pseudo_focus_for_all_buttons();
        UTL.MakeElementFocusable(DIALOG500.case_element);
        DIALOG500.case_element.focus();
    }

    public static perform_CLOSE() {
        document.body.removeChild(DIALOG500.overlay_element);
        DIALOG500.popup_exist = false;
    }

    public static perform_ok() {
        //const output_result = true
        //perform_given_pars(output_result);
        DIALOG500.perform_CLOSE();
    }

    public static perform_cancel() {
        //alert("cc");
        //const output_result = false;
        //perform_given_pars(output_result);
        DIALOG500.perform_CLOSE();
    }


    public static trans_task_to_string(task: VECTOR_Task): string {
        const info: VECTOR_Info = task.info; // short name
        let str = "";
        //str += `(${index})`;
        //str += " ";
        str += ".";
        str += `${info.row}`;
        str += ".";
        str += `${info.column}`;
        str += ".";
        str += `${info.fieldname}`;
        str += "...........";
        str += `${info.fieldvalue}`;
        return str;
    }

    public static create_text_to_show(p_vector_array: VECTOR_Task[], p_curr_task: VECTOR_Task): string {
        let str = "";
        // how do i loop on the array
        // לולאת for קלאסית
        for (let i = 0; i < p_vector_array.length; i++) {
            const task = p_vector_array[i];
            const task_str: string = DIALOG500.trans_task_to_string(task);
            str += task_str;
            str += "<br>";
        }
        if (true) {
            str += "Task Curr" + ": " + p_curr_task.info.row + "\n";
            const task = p_curr_task;
            const task_str: string = DIALOG500.trans_task_to_string(task);
            str += task_str;
        }
        return str;
    }

    public static create_dialog_INA(p_vector_array: VECTOR_Task[], p_curr_task: VECTOR_Task) {
        debugger;
        if (DIALOG500.popup_exist == false) {
            //alert("1");
            const str1: string = JSON.stringify(p_vector_array, null, 2);
            const str2: string = JSON.stringify(p_curr_task, null, 2);
            const str3: string = DIALOG500.create_text_to_show(p_vector_array, p_curr_task);

            //const temp_str = `${str1}------------------------------${str2}`;
            const temp_str = str3;
            DIALOG500.create_dialog(temp_str);
            //alert("2");
        }
    }
}